/* eslint-disable class-methods-use-this, import/no-extraneous-dependencies */
import useJwt from '@/auth/jwt/useJwt'

export default class WhatsappChatService {
  // listagem usada na tela Chat Follow - Acompanhamento Pós Chat
  static listToChatFollow(filters) {
    let params = {}
    if (filters !== undefined) {
      params = Object.fromEntries(Object.entries(filters).filter(filter => filter[1] !== '' && filter[1] !== 'all'))
    }

    params.page = 0

    return useJwt.get('/whatsapp-chats/list-to-screen-chat-follow', params)
  }
}
